import React, { Fragment } from 'react';
import { useBottomDialogDispatch } from '../../../components/BottomDialog/BottomDialogContext';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { ProgramEntry } from '../../../components/Program/ProgramEntry/ProgramEntry';
import { List, StyledProgram } from '../../../components/Program/ProgramEntry/ProgramEntry.styles';
import { ProgramEntryListPlaceholder } from '../../../components/Program/ProgramEntry/ProgramEntryListPlaceholder';
import { DetailContent } from '../../../components/TvGuide/Detail/DetailContent';
import { jsx as _jsx } from "react/jsx-runtime";
const showImageThreshold = 0.8;
export const ChannelPrograms = ({
  programGuide,
  isLoading
}) => {
  const dispatch = useBottomDialogDispatch();
  const numberOfProgramEntries = programGuide?.programList?.length ?? 0;
  const numberOfProgramImages = programGuide?.programList.filter(entry => !entry.imageIsFallbackUrl).length ?? 0;
  const showImages = numberOfProgramImages / showImageThreshold >= numberOfProgramEntries;
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(PlayContainer, {
      children: /*#__PURE__*/_jsx(List, {
        children: isLoading ? /*#__PURE__*/_jsx(ProgramEntryListPlaceholder, {
          placeholderChannelCount: 10
        }) : programGuide?.programList.map(program => /*#__PURE__*/_jsx(StyledProgram, {
          children: /*#__PURE__*/_jsx(ProgramEntry, {
            program: program,
            channel: programGuide.channel,
            entryTitle: program.title,
            entrySubtitle: program.subtitle,
            onSelect: () => {
              dispatch({
                type: 'show-dialog',
                dialog: /*#__PURE__*/_jsx(DetailContent, {
                  selectedProgram: {
                    program,
                    channel: programGuide.channel
                  },
                  onClose: () => dispatch({
                    type: 'remove-dialog'
                  }),
                  analyticsPageId: 'tvGuideByChannel'
                })
              });
            },
            showChannelIcon: false,
            showImage: showImages,
            analyticsPageId: "tvGuideByChannel"
          })
        }, program.title + program.startTime))
      })
    })
  });
};